<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img :src="user.avatar500x500" class="img-avatar">
          <!-- {{user.email}} -->
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>{{$t('header.setting')}}</strong></b-dropdown-header>
        <b-dropdown-item @click="profile"><i class="fa fa-user"></i> {{$t('header.profile')}}</b-dropdown-item>
        <!-- <b-dropdown-item><i class="fa fa-wrench"></i> Settings</b-dropdown-item>
        <b-dropdown-item @click="profile"><i class="fa fa-qrcode"></i> QR Code</b-dropdown-item> -->
        <!-- <b-dropdown-header tag="div" class="text-center"><strong>Language</strong></b-dropdown-header>
        <b-dropdown-item v-for="lang in languages" :key="lang.code" @click="selectLanguage(lang)"><i class="fa fa-language"></i> {{lang.name}}</b-dropdown-item> -->
        <!-- <b-dropdown-divider></b-dropdown-divider> -->
        <b-dropdown-item @click="Logout"><i class="fa fa-lock"></i> {{$t('header.signout')}}</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import Helper from '@/Helper'
import Echo from 'laravel-echo'
import ProfileService from '@/service/profile'

export default {
  name: 'header-dropdown',
  data: () => {
    return {
      itemsCount: 42
    }
  },
  computed: {
    user () {
      return this.$store.getters['Profile/getProfile']
    },
    languages () {
      return this.$store.state.I18n.languages
    }
  },
  mounted () {
    // window.io = require('socket.io-client')
    // window.Echo = new Echo({
    //   broadcaster: 'socket.io',
    //   host: process.env.URL_SOCKET,
    //   auth: {
    //     headers: {
    //       'Authorization': 'Bearer' + Helper.getToken()
    //     }
    //   }
    // })
    if (this.user.length === 0) {
      this.$loading.start()
      this.$store.dispatch('Profile/getProfile').then(res => {
        this.$loading.complete()
        window.Echo.leave('chats.' + res.id)
        window.Echo.private('chats.' + res.id).listen('.chats', (data) => {
          this.$store.dispatch('Chat/receiveMessage', data)
        })
        window.Echo.private('App.Models.User.' + res.id).notification((notification) => {
        // console.log(notification)
          this.$store.dispatch('Notification/pushNotification', notification)
          this.$store.dispatch('Profile/addTotalNotification')
          this.$notify({
            group: 'notification',
            title: this.$t('notify.notify'),
            text: this.$t('notify.notification')
          })
        })
      }).catch(errors => {
        this.$loading.complete()
      })
    }
  },
  methods: {
    selectLanguage (lang) {
      this.$store.dispatch('setLang', lang)
      window.location.reload()
    },
    Logout () {
      this.$loading.start()
      ProfileService.logout().then(res => {
        window.Echo.leave('App.Models.User.' + this.user.id)
        window.Echo.leave('chats.' + this.user.id)
        this.$loading.complete()
        Helper.clearLocalStorage()
        window.location.href = '/login'
        // this.$router.push('/login')
      }).catch(errors => {
        this.$loading.fail()
      })
    },

    profile () {
      this.$router.push('/profile')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/User.vue